
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/posts/[slug]",
      function () {
        return require("private-next-pages/admin/posts/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/posts/[slug]"])
      });
    }
  